var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('goBack',{attrs:{"title":_vm.$route.query.title}}),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }